<div *ngIf="actRout?.snapshot?.queryParams?.offer && config?.type !== 'v3'" class="offer-note" [ngClass]="{'v2': v2}">
  <div  class="logo">
    <i class="material-icons">done</i>
  </div>
  <div class="text">We will add another <strong><app-currency-icon [currency]="actRout.snapshot?.queryParams?.currency"></app-currency-icon>{{actRout?.snapshot?.queryParams?.offer}}</strong> from our end</div>
</div>

<div *ngIf="actRout?.snapshot?.queryParams?.offer && config?.type === 'v3'" class="offer-note" [ngClass]="'theme-'+config?.type">
  <div class="content">
    <em class="material-icons">check_circle</em>
    <div class="text"><strong>First <app-currency-icon [currency]="actRout.snapshot?.queryParams?.currency"></app-currency-icon> {{actRout?.snapshot?.queryParams?.offer}} added by Ketto</strong></div>
  </div>
</div>
